import React from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import DashBoardLayout from './Layouts/DashBoardLayout';
import LandingPage from './Pages/LandingPage';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import NotFound from './Pages/NotFound';

function App() {
  return (
    <React.Fragment>
      <Routes>

        <Route
          path="/"
          element={
            <DashBoardLayout>
              <LandingPage />
            </DashBoardLayout>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <DashBoardLayout>
              <PrivacyPolicy />
            </DashBoardLayout>
          }
        />

        <Route
          path="*"
          element={
            <DashBoardLayout>
              <NotFound />
            </DashBoardLayout>
          }
        />

      </Routes>
    </React.Fragment>
  );
}

export default App;
